export default {
  module: {
    name: 'Название источника',
    type: 'Тип модуля',
    version: 'Версия',
    latest_version: 'Последняя версия',
    description: 'Описание',
    upgrade: 'Обновить'
  },
  user: {
    title: 'Пользователь',
    management: 'Управление пользователями',
    maintenance: 'Обслуживание',
    licensing: 'Лицензирование',
    modules: 'Модули',
    misc: 'Разное',
    login: 'Логин',
    password: 'Пароль',
    name: 'Имя',
    role: 'Роль',
    select_role: 'Выберите роль',
    login_table: 'Логин пользователя',
    add_new: 'Добавить нового пользователя',
    update: 'Обновить пользователя',
    wrongCredentials: 'Неправильный логин или пароль'
  },
  current_user: {
    title: 'Текущий пользователь'
  },
  users: {
    title: 'Все пользователи'
  },
  alarms: {
    title: 'Уведомления',
    servers_status: 'Состояние серверов',
    pipelines_status: 'Состояние каналов',
    db_status: 'Состояние БД',
    user_notifications: 'Пользовательские уведомления',
    events: 'События'
  },
  db: {
    title: 'База данных'
  },
  license: {
    title: 'Лицензия'
  },
  backup: {
    title: 'Все настройки'
  },
  logs: {
    title: 'Логи'
  },
  change: {
    name: 'Изменить имя',
    password: 'Изменить пароль'
  }
}
